import { useTranslation } from 'react-i18next';

const PRESETS = {
  insta1080: { width: 1080, height: 1080, quality: 1 },
  print2048: { width: 2048, height: 2048, quality: 1 },
  custom: null,
};

export default function ExportSettings({ options, onChange }) {
  const { t } = useTranslation();

  const currentPreset =
    options.width === 1080 && options.height === 1080
      ? 'insta1080'
      : options.width === 2048 && options.height === 2048
        ? 'print2048'
        : 'custom';

  const update = (patch) => onChange({ ...options, ...patch });

  return (
    <div className="ardosz-export-grid">
      <div className="ardosz-control-group">
        <label htmlFor="preset-select">{t('formatPreset')}</label>
        <select
          id="preset-select"
          value={currentPreset}
          onChange={(event) => {
            const preset = PRESETS[event.target.value];
            if (preset) {
              onChange(preset);
            }
          }}
        >
          <option value="insta1080">{t('preset1080')}</option>
          <option value="print2048">{t('preset2048')}</option>
          <option value="custom">{t('presetCustom')}</option>
        </select>
      </div>

      <div className="ardosz-control-group">
        <label htmlFor="width-input">{t('exportWidth')}</label>
        <input
          id="width-input"
          type="number"
          min="256"
          max="4096"
          value={options.width}
          onChange={(event) => update({ width: Number(event.target.value) || 1080 })}
        />
      </div>

      <div className="ardosz-control-group">
        <label htmlFor="height-input">{t('exportHeight')}</label>
        <input
          id="height-input"
          type="number"
          min="256"
          max="4096"
          value={options.height}
          onChange={(event) => update({ height: Number(event.target.value) || 1080 })}
        />
      </div>

      <div className="ardosz-control-group">
        <label htmlFor="quality-input">{t('exportQuality')}</label>
        <input
          id="quality-input"
          type="range"
          min="0.5"
          max="1"
          step="0.01"
          value={options.quality}
          onChange={(event) => update({ quality: Number(event.target.value) || 1 })}
        />
      </div>
    </div>
  );
}
